module.exports = __webpack_public_path__ + "img/undraw_Cloud_docs_re_xjht.c69c9cbc.svg";